<mat-card>
  <mat-card-content>
    <mat-card-title>
      Gestisci adesioni
    </mat-card-title>

    <div fxLayout="row wrap">
      <div fxFlex="40%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <input [(ngModel)]="txtRiferimento" id="Riferimento" matInput
                 placeholder="Riferimento">
        </mat-form-field>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div fxFlex="40%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <input [(ngModel)]="txtNominativoReferente" id="NominativoReferente" matInput
                 placeholder="Nominativo/Referente">
        </mat-form-field>
      </div>

      <div fxFlex="15%;" fxFlex.xs="100%">
        <button mat-raised-button
                color="primary"
                (click)="btnCerca()">
          Cerca
        </button>
      </div>
    </div>
      <!--
    <div fxFlex="70%;" fxFlex.xs="100%" align="right">
      <button mat-raised-button
              color="primary" (click)="btnAggiungiModifica(-1)">
        Nuovo
      </button>
    </div>


    <div fxFlex="25%;" fxFlex.xs="100%" align="right">
      <button mat-raised-button color="primary">
        <a style="color:white" csvLink delimiter=";" [data]="lstElenco" filename="Atenei">Esporta CSV</a>
      </button>
    </div>
          -->

  </mat-card-content>
</mat-card>


<mat-card>
  <mat-card-content>
    
    <div fxLayout="row wrap">
      <div fxFlex.gt-sm="50%">
        <mat-form-field class="full-width">
          <input matInput
                 placeholder="Filtra"
                 [(ngModel)]="txtFiltra"
                 id="txtFiltra"
                 value=""
                 (keyup)='updateFilter($event)'>
        </mat-form-field>
      </div>
    </div>
   
    <ngx-datatable #grdGestisciAdesioni
                   [rows]="lstElenco"
                   [columnMode]="'flex'"
                   [headerHeight]="50"
                   [footerHeight]="50"
                   [limit]="30"
                   [rowHeight]="'auto'">
   
  <ngx-datatable-column name="" [flexGrow]="0.5">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div style="float:left">
        <button mat-icon-button mat-sm-button color="primary"
                class="mr-1"
                (click)="btnAggiungiModifica()"
                matTooltip="Modifica">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

      <ngx-datatable-column name="Riferimento"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Riferimento">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Riferimento }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Nominativo/Referente"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Cognome">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Cognome}} {{row?.Nome}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Data Inserimento"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="DataRichiesta">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.DataRichiesta | date: 'dd/MM/yyyy' }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Data Pagamento"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="DataPagamento">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.DataPagamento | date: 'dd/MM/yyyy' }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Pdf"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Pdf">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span *ngIf="idFattura > 0">
            <mat-icon>picture_as_pdf</mat-icon>
          </span>
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </mat-card-content>
</mat-card>
